import { render, staticRenderFns } from "./AccommodationPriceInput.vue?vue&type=template&id=36aad577"
import script from "./AccommodationPriceInput.vue?vue&type=script&lang=js"
export * from "./AccommodationPriceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports